/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-03 16:47:37
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-08 14:34:16
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelLegal/LegalPageEditor/tools.ts
 */

import _ from 'lodash';
import { generateErrorKey, timeoutScroll as scroll } from 'src/tools/helper';
import { EnumCollapseId } from './slice';
import { changedStatus } from 'src/tools/constant';
import { reduxUpdatedStatusControl } from 'src/tools/helper';

const pageSettingValidation = (pageSetting) => {
  const _pageSetting = _.cloneDeep(pageSetting || {});
  const { isNameDuplicate, name, nameIsValid } = _pageSetting;
  let flag = false;
  if (!name) {
    _pageSetting[generateErrorKey('name')] = true;
    flag = true;
  }
  if (!nameIsValid) {
    _pageSetting[generateErrorKey('nameIsValid')] = true;
    flag = true;
  }
  if (isNameDuplicate) {
    _pageSetting[generateErrorKey('isNameDuplicate')] = true;
    flag = true;
  }
  return { hasError: flag, data: _pageSetting };
};

const seoSettingValidation = (seoSetting) => {
  const _seoSetting = _.cloneDeep(seoSetting || {});
  const { slugValid } = _seoSetting;
  return { hasError: !slugValid };
};

const legalSettingValidation = (legalSetting) => {
  const _legalSetting = _.cloneDeep(legalSetting || {});
  const {
    versionRemarks,
    useDefaultLegalSetting,
    entityName,
    entityRegistrationNumber,
  } = _legalSetting;
  let flag = false;
  if (!versionRemarks) {
    _legalSetting[generateErrorKey('versionRemarks')] = true;
    flag = true;
  }
  if (!useDefaultLegalSetting && !entityName) {
    _legalSetting[generateErrorKey('entityName')] = true;
    flag = true;
  }
  if (!useDefaultLegalSetting && !entityRegistrationNumber) {
    _legalSetting[generateErrorKey('entityRegistrationNumber')] = true;
    flag = true;
  }
  return { hasError: flag, data: _legalSetting };
};

const contentValidation = (content) => {
  const _content = _.cloneDeep(content || {});
  const { isEmpty } = _content;
  let flag = false;
  if (isEmpty) {
    _content[generateErrorKey('content')] = true;
    flag = true;
  }
  return { hasError: flag, data: _content };
};

const validation = (state, isPrimary) => {
  const { pageSetting, seoSetting, legalSetting, content } = state || {};

  const { hasError: pageSettingHasError, data: _pageSetting } =
    pageSettingValidation(pageSetting);
  if (pageSettingHasError) {
    state.collapseOpen[EnumCollapseId.PageSetting] = true;
    state.pageSetting = _pageSetting;
    state.timeoutRef.push(scroll('SalesChannelLegalPageEditorPageName'));
    return false;
  }

  if (isPrimary) {
    const { hasError: seoSettingHasError } = seoSettingValidation(seoSetting);
    if (seoSettingHasError) {
      state.collapseOpen[EnumCollapseId.SeoSetting] = true;
      state.timeoutRef.push(
        scroll('SalesChannelLegalPageEditorSeoSettingSlug'),
      );
      return false;
    }

    const { hasError: legalSettingHasError, data: _legalSetting } =
      legalSettingValidation(legalSetting);
    if (legalSettingHasError) {
      state.collapseOpen[EnumCollapseId.LegalSetting] = true;
      state.legalSetting = _legalSetting;
      state.timeoutRef.push(scroll('SalesChannelLegalPageEditorLegalSetting'));
      return false;
    }
  }

  const { hasError: contentHasError, data: _contentSetting } =
    contentValidation(content);
  if (contentHasError) {
    state.collapseOpen[EnumCollapseId.Content] = true;
    state.content = _contentSetting;
    state.timeoutRef.push(scroll('SalesChannelLegalPageEditorContent'));
    return false;
  }

  return true;
};

const convertDataFromReduxToServer = (state) => {
  const {
    pageSetting,
    seoSetting,
    legalSetting,
    content: contentSetting,
    uuid,
    salesChannelUuid,
    storeUuid,

    miniProgramShare,
  } = state;
  const { name } = pageSetting;
  const { title, description, urlSlug, slugValid } = seoSetting;
  const {
    versionRemarks,
    useDefaultLegalSetting,
    entityName,
    entityRegistrationNumber,
    consentAttributes = [],
  } = legalSetting;
  const { content } = contentSetting;

  return {
    consentAttributes: consentAttributes.map((i) => i.title),
    name,
    uuid,
    salesChannelUuid,
    content,
    versionRemarks,
    useDefaultLegalSetting,
    entityName,
    entityRegistrationNumber,
    storeUuid,
    miniProgramShare,
    seoSetting: { title, description, urlSlug, slugValid },
  };
};

const convertDataFromServerToRedux = (data) => {
  const {
    name,
    uuid,
    salesChannelUuid,
    content: _content,
    versionRemarks,
    useDefaultLegalSetting,
    entityName,
    entityRegistrationNumber,
    seoSetting,
    consentAttributes = [],
    termConditionUuids = [],
    salesChannelName,
    miniProgramPageInfo,
    miniProgramShare,
  } = data || {};
  const pageSetting = { name, nameIsValid: true };
  const legalSetting = {
    versionRemarks,
    useDefaultLegalSetting,
    entityName,
    entityRegistrationNumber,
    consentAttributes: consentAttributes.map((i) => ({ title: i, value: i })),
  };
  const content = { content: _content };
  return {
    pageSetting,
    seoSetting,
    legalSetting,
    content,
    uuid,
    salesChannelUuid,
    hasLinkedToTC: termConditionUuids.length > 0,
    salesChannelName,
    miniProgramPageInfo,
    miniProgramShare,
    ...changedStatus,
    ...reduxUpdatedStatusControl,
  };
};

export {
  validation,
  convertDataFromReduxToServer,
  convertDataFromServerToRedux,
};
